import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=d140a430&"
import script from "./Bottom.vue?vue&type=script&lang=ts&"
export * from "./Bottom.vue?vue&type=script&lang=ts&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=d140a430&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports